/* ==========================================================================
   Lumbeard — JS del tema (sin dependencias)
   ========================================================================== */
(function () {
  "use strict";

  var moneyFormat = function (cents) {
    var value = (cents / 100).toLocaleString("es-MX", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return "$" + value;
  };

  /* ---------------- Toast ---------------- */
  var toastEl = null;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.add("is-visible");
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () {
      toastEl.classList.remove("is-visible");
    }, 2600);
  }

  /* ---------------- Announcement ticker ---------------- */
  function initAnnouncement() {
    document.querySelectorAll("[data-announcement]").forEach(function (bar) {
      var track = bar.querySelector(".announcement__track");
      var items = track ? track.children.length : 0;
      if (!track || items <= 1) return;
      var index = 0;
      setInterval(function () {
        index = (index + 1) % items;
        track.style.transform = "translateY(-" + index * 38 + "px)";
      }, 3200);
    });
  }

  /* ---------------- Hero carousel ----------------
     Solo la primera diapositiva trae su imagen en el HTML. Las demás traen
     data-src / data-srcset y se cargan cuando la página ya terminó de cargar
     (o justo al mostrarse), para que en celular no compitan con la primera
     imagen. */
  function heroLoadSlide(slide) {
    if (!slide) return;
    var img = slide.querySelector("img[data-src]");
    if (!img) return;
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      img.removeAttribute("data-srcset");
    }
    img.src = img.dataset.src;
    img.removeAttribute("data-src");
  }

  function initHero() {
    document.querySelectorAll("[data-hero]").forEach(function (hero) {
      var slides = hero.querySelectorAll(".hero__slide");
      var dots = hero.querySelectorAll(".hero__dot");
      var contents = hero.querySelectorAll("[data-hero-content]");
      if (slides.length <= 1) return;
      var idx = 0;
      var paused = false;

      function loadRest() {
        setTimeout(function () {
          slides.forEach(heroLoadSlide);
        }, 1200);
      }
      if (document.readyState === "complete") {
        loadRest();
      } else {
        window.addEventListener("load", loadRest);
      }

      function show(next) {
        idx = (next + slides.length) % slides.length;
        heroLoadSlide(slides[idx]);
        slides.forEach(function (s, i) {
          s.classList.toggle("is-active", i === idx);
        });
        dots.forEach(function (d, i) {
          d.classList.toggle("is-active", i === idx);
          var span = d.querySelector("span");
          if (i === idx && !span) {
            d.innerHTML = "<span></span>";
          } else if (i !== idx) {
            d.innerHTML = "";
          }
        });
        contents.forEach(function (c, i) {
          c.hidden = i !== idx;
        });
      }

      hero.querySelectorAll("[data-hero-next]").forEach(function (b) {
        b.addEventListener("click", function () {
          show(idx + 1);
        });
      });
      hero.querySelectorAll("[data-hero-prev]").forEach(function (b) {
        b.addEventListener("click", function () {
          show(idx - 1);
        });
      });
      dots.forEach(function (d, i) {
        d.addEventListener("click", function () {
          show(i);
        });
      });
      hero.addEventListener("mouseenter", function () {
        paused = true;
      });
      hero.addEventListener("mouseleave", function () {
        paused = false;
      });

      setInterval(function () {
        if (!paused) show(idx + 1);
      }, 6000);

      show(0);
    });
  }

  /* En el editor de temas, al recargar la sección se cargan todas sus imágenes. */
  document.addEventListener("shopify:section:load", function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    e.target.querySelectorAll(".hero__slide").forEach(heroLoadSlide);
  });

  /* ---------------- Cuenta regresiva hasta medianoche ---------------- */
  function initCountdown() {
    var clocks = document.querySelectorAll("[data-countdown]");
    if (!clocks.length) return;
    var pad = function (n) {
      return String(n).padStart(2, "0");
    };
    function tick() {
      var now = new Date();
      var midnight = new Date(now.getTime());
      midnight.setHours(24, 0, 0, 0);
      var diff = Math.max(0, midnight.getTime() - now.getTime());
      var h = pad(Math.floor(diff / 3600000));
      var m = pad(Math.floor((diff % 3600000) / 60000));
      var s = pad(Math.floor((diff % 60000) / 1000));
      clocks.forEach(function (clock) {
        var eh = clock.querySelector("[data-countdown-hours]");
        var em = clock.querySelector("[data-countdown-minutes]");
        var es = clock.querySelector("[data-countdown-seconds]");
        if (eh) eh.textContent = h;
        if (em) em.textContent = m;
        if (es) es.textContent = s;
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------------- Pestañas (Sobre tu pedido) ---------------- */
  function initTabs() {
    document.querySelectorAll("[data-tabs]").forEach(function (root) {
      var tabs = root.querySelectorAll("[data-tab]");
      var panels = root.querySelectorAll("[data-tab-panel]");
      if (!tabs.length) return;
      function show(value) {
        tabs.forEach(function (t) {
          var on = t.dataset.tab === value;
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-selected", on ? "true" : "false");
        });
        panels.forEach(function (p) {
          p.hidden = p.dataset.tabPanel !== value;
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener("click", function () {
          show(t.dataset.tab);
        });
      });
      show(tabs[0].dataset.tab);
    });
  }

  /* ---------------- Reseñas de Revie ----------------
     Revie inyecta en la página las reseñas del producto (widget 2, en JSON) y
     los testimonios de la tienda (widget 4, ya en el HTML), además del total y
     la media. Rellenamos con ellos el diseño de la ficha y de la portada para
     que se actualicen solos. Si la página actual no trae ningún bloque de
     Revie, se piden una vez a una versión ligera de la portada que solo trae
     el bloque de Revie (/?view=revie-data, plantilla index.revie-data) y se
     guardan en caché unas horas. */
  var RV_STAR_ON =
    '<svg class="is-on" viewBox="0 0 24 24" width="14" height="14"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
  var RV_STAR_OFF =
    '<svg viewBox="0 0 24 24" width="14" height="14"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
  var RV_BADGE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M12 2 15 5h4v4l3 3-3 3v4h-4l-3 3-3-3H5v-4l-3-3 3-3V5h4z"/><path d="m9 12 2 2 4-4"/></svg>';
  var RV_MONTHS = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  var RV_CACHE_KEY = "revie-data";
  var RV_CACHE_TTL = 6 * 60 * 60 * 1000;
  var RV_CACHE_MAX = 12;
  var RV_DATA_URL = "/?view=revie-data";

  function rvEscape(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function rvStars(rating) {
    var full = Math.round(parseFloat(rating) || 0);
    var out = "";
    for (var i = 1; i <= 5; i++) out += i <= full ? RV_STAR_ON : RV_STAR_OFF;
    return '<div class="stars"><span class="stars__icons" aria-hidden="true">' + out + "</span></div>";
  }

  function rvDate(value) {
    var parts = String(value || "").split("T")[0].split("-");
    if (parts.length !== 3 || !parts[0]) return "";
    var month = RV_MONTHS[parseInt(parts[1], 10) - 1] || "";
    return parseInt(parts[2], 10) + " " + month + " " + parts[0];
  }

  function rvInitials(name) {
    return String(name || "")
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map(function (part) {
        return part.charAt(0);
      })
      .join("")
      .toUpperCase();
  }

  /* Media y total de la tienda. */
  function revieTotalsFrom(scope) {
    if (!scope || !scope.querySelector) return null;
    var list = scope.querySelector("#revieListTestimoniales");
    var head = list && list.parentElement ? list.parentElement.querySelector(".topTest") : null;
    if (!head) head = scope.querySelector(".topTest");
    if (!head) return null;
    var numberEl = head.querySelector("div");
    var count = numberEl ? parseInt(String(numberEl.textContent).replace(/[^0-9]/g, ""), 10) : 0;
    if (!count) return null;
    var rating = 0;
    var starEl = head.querySelector(".titleRevie") || head.querySelector(".rv-stars");
    if (starEl) {
      var match = String(starEl.getAttribute("title") || "").match(/([0-9]+(?:[.,][0-9]+)?)/);
      if (match) rating = parseFloat(match[1].replace(",", "."));
      if (!rating) {
        var style = String(starEl.getAttribute("style") || "").match(/--rating:\s*([0-9.]+)/);
        if (style) rating = parseFloat(style[1]);
      }
    }
    return { count: count, rating: rating };
  }

  /* Lista de reseñas: primero las del producto (widget 2) y si no, los
     testimonios de la tienda (widget 4). */
  function revieListFrom(scope) {
    if (!scope || !scope.querySelector) return [];
    var jsonEl = scope.querySelector("[data-rvw2-list]");
    if (jsonEl) {
      try {
        var rows = JSON.parse(jsonEl.textContent) || [];
        if (rows.length) {
          return rows.map(function (row) {
            var customer = row.customer || {};
            var name = [customer.firstName, customer.lastName].filter(Boolean).join(" ");
            return {
              name: name || "Cliente",
              stars: row.stars,
              text: row.comment,
              date: row.createdAt
            };
          });
        }
      } catch (e) {}
    }
    var items = scope.querySelectorAll(".gridTestimoniales .p-test");
    var out = [];
    Array.prototype.forEach.call(items, function (el) {
      var comment = el.querySelector(".tm-rev-com");
      var text = comment ? comment.textContent.trim() : "";
      if (!text) return;
      out.push({
        name: el.getAttribute("data-name") || "Cliente",
        stars: parseFloat(el.getAttribute("data-stars")) || 0,
        text: text,
        date: ""
      });
    });
    return out;
  }

  function revieThousands(value) {
    return Number(value).toLocaleString("en-US");
  }

  function revieApplyTotals(totals) {
    if (!totals) return;
    document.querySelectorAll("[data-revie-shop-count]").forEach(function (el) {
      el.textContent = revieThousands(totals.count);
    });
    document.querySelectorAll("[data-revie-shop-label]").forEach(function (el) {
      el.textContent = String(el.textContent).replace(/[0-9][0-9.,]*/, revieThousands(totals.count));
    });
    if (!totals.rating) return;
    document.querySelectorAll("[data-revie-shop-rating]").forEach(function (el) {
      var mode = el.getAttribute("data-revie-shop-rating");
      var value = totals.rating.toFixed(1);
      if (mode === "comma") value = value.replace(".", ",");
      if (mode === "over5") value = value + "/5";
      el.textContent = value;
    });
  }

  function revieApplyList(list, grid) {
    if (!list || !list.length || !grid) return;
    var limit = parseInt(grid.dataset.revieLimit || "6", 10);
    grid.innerHTML = list
      .slice(0, limit)
      .map(function (review) {
        var date = rvDate(review.date);
        return (
          '<div class="rv__card">' +
          '<div class="rv__head">' +
          rvStars(review.stars) +
          (date ? '<span class="rv__date">' + date + "</span>" : "") +
          "</div>" +
          '<div class="rv__meta"><span class="rv__avatar">' +
          rvInitials(review.name) +
          "</span><div>" +
          '<p class="rv__name">' +
          rvEscape(review.name) +
          " " +
          RV_BADGE +
          "</p>" +
          '<p class="rv__verified">Compra verificada</p></div></div>' +
          '<p class="rv__text">' +
          rvEscape(review.text) +
          "</p>" +
          "</div>"
        );
      })
      .join("");
  }

  function initRevie() {
    var grid = document.querySelector("[data-revie-cards]");
    var targets = document.querySelector(
      "[data-revie-shop-count], [data-revie-shop-label], [data-revie-shop-rating]"
    );
    if (!grid && !targets) return;

    var totals = revieTotalsFrom(document);
    var list = grid ? revieListFrom(document) : [];
    if (totals) revieApplyTotals(totals);
    if (list.length) revieApplyList(list, grid);

    var needTotals = targets && !totals;
    var needList = grid && !list.length;
    if (!needTotals && !needList) return;

    var cached = null;
    try {
      cached = JSON.parse(sessionStorage.getItem(RV_CACHE_KEY) || "null");
    } catch (e) {
      cached = null;
    }
    if (cached && cached.at && Date.now() - cached.at < RV_CACHE_TTL) {
      if (cached.totals) revieApplyTotals(cached.totals);
      if (cached.list) revieApplyList(cached.list, grid);
      return;
    }

    fetch(RV_DATA_URL, { credentials: "same-origin" })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var found = { totals: revieTotalsFrom(doc), list: revieListFrom(doc).slice(0, RV_CACHE_MAX) };
        try {
          sessionStorage.setItem(
            RV_CACHE_KEY,
            JSON.stringify({ at: Date.now(), totals: found.totals, list: found.list })
          );
        } catch (e) {}
        if (found.totals) revieApplyTotals(found.totals);
        if (found.list && found.list.length) revieApplyList(found.list, grid);
      })
      .catch(function () {});
  }

  /* ---------------- Acordeones ---------------- */
  function initAccordions() {
    document.querySelectorAll("[data-accordion] .accordion__trigger").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest(".accordion__item");
        var group = btn.closest("[data-accordion]");
        var single = group && group.dataset.accordion === "single";
        if (single) {
          group.querySelectorAll(".accordion__item").forEach(function (other) {
            if (other !== item) other.classList.remove("is-open");
          });
        }
        item.classList.toggle("is-open");
      });
    });
  }

  /* ---------------- Menú móvil ---------------- */
  function initMobileMenu() {
    var menu = document.querySelector("[data-mobile-menu]");
    var header = document.querySelector(".header");
    if (!menu) return;
    document.querySelectorAll("[data-menu-open]").forEach(function (b) {
      b.addEventListener("click", function () {
        menu.classList.add("is-open");
        if (header) header.classList.add("is-menu-open");
      });
    });
    menu.querySelectorAll("[data-menu-close]").forEach(function (b) {
      b.addEventListener("click", function () {
        menu.classList.remove("is-open");
        if (header) header.classList.remove("is-menu-open");
      });
    });
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        menu.classList.remove("is-open");
        if (header) header.classList.remove("is-menu-open");
      });
    });
  }

  /* ---------------- Galería de producto ---------------- */
  function initGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-gallery-main]");
      gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          if (!main) return;
          main.src = thumb.dataset.full || thumb.querySelector("img").src;
          gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
            t.classList.remove("is-active");
          });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  /* ---------------- Carrito ---------------- */
  var drawer = null;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  function renderCart(cart) {
    if (!drawer) return;
    var body = drawer.querySelector("[data-cart-body]");
    var count = drawer.querySelector("[data-cart-count]");
    var total = drawer.querySelector("[data-cart-total]");
    var headerCount = document.querySelector("[data-header-cart-count]");

    if (count) count.textContent = cart.item_count;
    if (headerCount) {
      headerCount.textContent = cart.item_count;
      headerCount.hidden = cart.item_count === 0;
    }
    if (total) total.textContent = moneyFormat(cart.total_price);

    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
        "<p>Tu carrito está vacío.</p></div>";
      return;
    }

    body.innerHTML = cart.items
      .map(function (item) {
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : "";
        return (
          '<div class="cart-line" data-line-key="' + item.key + '">' +
          '<img src="' + img + '" alt="">' +
          '<div class="cart-line__body">' +
          '<p class="cart-line__title">' + item.product_title + "</p>" +
          '<p class="cart-line__price">' + moneyFormat(item.final_line_price) + "</p>" +
          '<div class="cart-line__row">' +
          '<span class="cart-line__qty">' +
          '<button type="button" data-qty-change="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Disminuir">−</button>' +
          "<span>" + item.quantity + "</span>" +
          '<button type="button" data-qty-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Aumentar">+</button>' +
          "</span>" +
          '<button type="button" class="cart-line__remove" data-qty-change="' + item.key + '" data-qty="0" aria-label="Eliminar">' +
          '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>' +
          "</button>" +
          "</div></div></div>"
        );
      })
      .join("");

    body.querySelectorAll("[data-qty-change]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        changeLine(btn.dataset.qtyChange, parseInt(btn.dataset.qty, 10));
      });
    });
  }

  function fetchCart() {
    return fetch("/cart.js").then(function (r) {
      return r.json();
    });
  }

  function changeLine(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(renderCart)
      .catch(function () {
        toast("No se pudo actualizar el carrito");
      });
  }

  function addToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        renderCart(cart);
        openDrawer();
        toast("Producto añadido al carrito");
      })
      .catch(function () {
        toast("No se pudo añadir el producto");
      });
  }

  function initCart() {
    drawer = document.querySelector("[data-cart-drawer]");

    document.querySelectorAll("[data-cart-open]").forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        fetchCart().then(renderCart);
        openDrawer();
      });
    });
    if (drawer) {
      drawer.querySelectorAll("[data-cart-close]").forEach(function (b) {
        b.addEventListener("click", closeDrawer);
      });
    }

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener("submit", function (e) {
        if (!drawer) return;
        e.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1);
      });
    });

    // Cantidad en la ficha de producto
    document.querySelectorAll("[data-qty-box]").forEach(function (box) {
      var input = box.querySelector("input");
      box.querySelectorAll("button").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var current = parseInt(input.value, 10) || 1;
          var next = btn.dataset.dir === "up" ? current + 1 : Math.max(1, current - 1);
          input.value = next;
        });
      });
    });
  }

  /* ---------------- Variantes y paquetes de producto ---------------- */
  var CHECK_ICON =
    '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function parseMoney(value) {
    if (!value) return 0;
    var n = parseFloat(String(value).replace(/[^0-9.,]/g, "").replace(/,/g, ""));
    return isNaN(n) ? 0 : n;
  }

  function initProductVariants() {
    document.querySelectorAll("[data-product]").forEach(function (root) {
      var idInput = root.querySelector("[data-variant-id]");
      var priceEl = root.querySelector("[data-price]");
      var compareEl = root.querySelector("[data-compare]");
      var offEl = root.querySelector("[data-off]");
      var mainImg = root.querySelector("[data-gallery-main]");
      var select = root.querySelector("[data-variant-select]");
      var bundles = root.querySelectorAll("[data-bundle]");
      var qtyInput = root.querySelector('[name="quantity"]');

      function sync(price, compare, image) {
        if (priceEl && price) priceEl.textContent = price;
        if (compareEl) {
          if (compare) {
            compareEl.textContent = compare;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (offEl) {
          var c = parseMoney(compare);
          var p = parseMoney(price);
          if (c > p && c > 0) {
            offEl.textContent = "−" + Math.round(((c - p) / c) * 100) + "%";
            offEl.hidden = false;
          } else {
            offEl.hidden = true;
          }
        }
        if (mainImg && image) mainImg.src = image;
      }

      if (select) {
        select.addEventListener("change", function () {
          var opt = select.options[select.selectedIndex];
          if (idInput) idInput.value = opt.value;
          sync(opt.dataset.price, opt.dataset.compare, opt.dataset.image);
        });
      }

      bundles.forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.disabled) return;
          if (idInput) idInput.value = btn.dataset.variantId;
          if (btn.dataset.price) {
            sync(btn.dataset.price, btn.dataset.compare, btn.dataset.image);
          }
          if (btn.dataset.qty && qtyInput) {
            qtyInput.value = btn.dataset.qty;
          }
          bundles.forEach(function (other) {
            var on = other === btn;
            other.classList.toggle("is-active", on);
            other.setAttribute("aria-pressed", on ? "true" : "false");
            var radio = other.querySelector(".buy__radio");
            if (radio) radio.innerHTML = on ? CHECK_ICON : "";
          });
        });
      });
    });
  }

  /* ---------------- Copiar cupón ---------------- */
  function initCouponCopy() {
    document.querySelectorAll("[data-copy-code]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var code = btn.dataset.copyCode;
        var done = function () {
          btn.classList.add("is-copied");
          toast("Cupón " + code + " copiado");
          setTimeout(function () {
            btn.classList.remove("is-copied");
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          done();
        }
      });
    });
  }

  /* ---------------- Newsletter (demo) ---------------- */
  function initNewsletter() {
    document.querySelectorAll("[data-newsletter]").forEach(function (wrap) {
      var form = wrap.querySelector("form");
      if (!form) return;
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var success = wrap.querySelector("[data-newsletter-success]");
        if (success) {
          form.hidden = true;
          success.hidden = false;
        }
        toast("¡Gracias! Te avisaremos de las próximas promociones.");
      });
    });
  }

  /* ---------------- Init ---------------- */
  function init() {
    initAnnouncement();
    initCountdown();
    initTabs();
    initHero();
    initAccordions();
    initMobileMenu();
    initGallery();
    initCart();
    initProductVariants();
    initCouponCopy();
    initRevie();
    initNewsletter();
    fetchCart()
      .then(function (cart) {
        var headerCount = document.querySelector("[data-header-cart-count]");
        if (headerCount) {
          headerCount.textContent = cart.item_count;
          headerCount.hidden = cart.item_count === 0;
        }
        if (drawer) renderCart(cart);
      })
      .catch(function () {});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
